import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AdminWorkGroupEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AdminWorkGroup";
        this.primaryEnterpriseComponent = "AdminWorkGroup";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminWorkGroup";
        eom.enterpriseComponent = "AdminWorkGroup";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminWorkGroupEmployee";
        eom.enterpriseComponent = "AdminWorkGroupEmployee";
        eom.relationship = "AdminWorkGroupAdminWorkGroupEmployee";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminWorkGroupOrganization";
        eom.enterpriseComponent = "AdminWorkGroupOrganization";
        eom.relationship = "AdminWorkGroupAdminWorkGroupOrganization";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminWorkGroupPosition";
        eom.enterpriseComponent = "AdminWorkGroupPosition";
        eom.relationship = "AdminWorkGroupAdminWorkGroupPosition";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminWorkGroupUserGroup";
        eom.enterpriseComponent = "AdminWorkGroupUserGroup";
        eom.relationship = "AdminWorkGroupAdminWorkGroupUserGroup";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default AdminWorkGroupEnterpriseObjectMetadata;